import { applyBackgroundImageFromCssRule } from 'js/main/package/apply-background-img-from-css-rule';

export default backgroundImage;

$(backgroundImage);

$(window)
    .ajaxSuccess(backgroundImage)
    .on('background-image', backgroundImage);

function backgroundImage() {
    $('[data-background-image]')
        .not('[data-background-image-resolved]')
        .each(async function(index, Element) {
            const $element = $(Element);
            const cssRule = $element.data('background-image');

            $element.attr({
                'data-background-image': '',
                'data-background-image-resolved': true,
            });

            await applyBackgroundImageFromCssRule(Element, cssRule);
        });
}



// WEBPACK FOOTER //
// ./js/main/plugin/data-background-image.js